import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import EditForm from '../../../../../../../features/components/Forms/EditForm'
import MultipleOptionsField from '../../../../../../ReusableFormFields/MultipleOptionsField'
import { getVideoUrlsData } from '../HeadlinesSection/helpers'

import { useEditAssetGroupSubmit } from '../../hooks'

import { selectedGoogleAdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'

import { VIDEO_ADS_URL } from '../../../../fields'
import { getInitialValues, validationSchema } from './fields'
import { googleAssetFieldType } from '../../../../../../../constants/ads'

const VideoUrlsSectionForm = ({ editItemData, isInternalAssetGroup, title, ...formProps }) => {
  const { assets, id: assetGroupId, account } = editItemData

  const { id: selectedAdAccountId } = useSelector(selectedGoogleAdAccountSelector)
  const adAccount = account || selectedAdAccountId

  const originalVideoUrlAssets = useMemo(() => getVideoUrlsData(assets), [assets])

  const initialValues = useMemo(() => getInitialValues(originalVideoUrlAssets), [originalVideoUrlAssets])

  const { purifiedFormik, onClearSubmit, isLoadingSelector, errorSelector, successSubmit } = useEditAssetGroupSubmit({
    originalSectionAssets: originalVideoUrlAssets,
    fieldType: googleAssetFieldType.YOUTUBE_VIDEO,
    sectionValueKey: VIDEO_ADS_URL,
    assetGroupId,
    isInternalAssetGroup,
    initialValues,
    validationSchema,
    adAccount
  })

  return (
    <EditForm
      formik={purifiedFormik}
      initialValues={initialValues}
      isLoadingSelector={isLoadingSelector}
      errorSelector={errorSelector}
      successSubmit={successSubmit}
      clearEditItem={onClearSubmit}
      {...formProps}
    >
      <MultipleOptionsField
        fieldLabel="YouTube Video link"
        listFieldName={VIDEO_ADS_URL}
        formik={purifiedFormik}
        minListQuantity={1}
        initialValue={'https://www.youtube.com'}
      />
    </EditForm>
  )
}

export default VideoUrlsSectionForm
